import ProviderComparisonTable from './ProviderComparisonTable';

export default ProviderComparisonTable;
